<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="sm">
            <template #body>

                <div class="flex w-full mt-4">
                    <div class="flex justify-start w-full px-2">
                        <span class="f-bold"> {{ $t('document') | capitalize }} </span>
                    </div>
                </div>
                <div class="flex w-full">
                    <div class="flex justify-start w-full px-2">
                        <span> {{ document.name }} </span>
                    </div>
                </div>

                <div class="flex w-full mt-4">
                    <div class="flex justify-start w-full px-2">
                        <span class="f-bold"> {{ $t('frequency') | capitalize }} </span>
                    </div>
                </div>
                <div class="flex w-full">
                    <div class="flex justify-start w-full px-2">
                        <span> {{ document.frequency }} </span>
                    </div>
                </div>


                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <!-- Start Date -->
                    <div class="px-2">
                        <div class="flex w-full mt-4">
                            <div class="flex justify-start w-full">
                                <label>{{ $t('start_date') | capitalize }}</label>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <div class="flex justify-center w-full">
                                <vs-input type="date" class="w-full" v-model="startDate" />
                            </div>
                        </div>
                    </div>

                    <!-- End Date -->
                    <div class="px-2">
                        <div class="flex w-full mt-4">
                            <div class="flex justify-start items-center w-full">
                                <label>{{ $t('end_date') | capitalize }}</label>
                            </div>
                        </div>
                        <div class="flex w-full">
                            <div class="flex justify-center items-center w-full">
                                <vs-input type="date" class="w-full" v-model="endDate" />
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Client -->
                <div class="flex w-full mt-4">
                    <div class="flex justify-start items-center w-full px-2">
                        <label for="">{{ $t('client') | capitalize }} (Opcional) </label>
                    </div>
                </div>
                <div class="flex w-full mb-4">
                    <div class="flex justify-center items-center w-full px-2">
                        <v-select :options="clients" class="w-full" label="ClientName" v-model="client" />
                    </div>
                </div>
                <div class="flex w-full mb-4" v-if="document.frequencyId != 8">
                    <div class="flex justify-center items-center w-full px-2">
                        <vs-checkbox v-model="autogenerate">
                            {{ $t('auto_generated') | capitalize }}
                        </vs-checkbox>
                    </div>
                </div>
                <div class="flex w-full mb-4">
                    <div class="flex justify-center items-center w-full px-2">
                        <vs-alert :active="displayAlert" color="danger">
                            <span>The date(s) you entered are invalid.</span>
                        </vs-alert>
                    </div>
                </div>

            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="submit">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue'
import BaseModal from '@/views/app/components/BaseModal'
import vSelect from 'vue-select'
import moment from 'moment'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    document: { type: Object, default: () => ({}) },
    clients: { type: Array, default: () => ([]) }
})

const emit = defineEmits(['submit', 'input'])

const client = ref(null)
const endDate = ref('')
const startDate = ref('')
const autogenerate = ref(false)
const displayAlert = ref(false)
watch(() => props.value, (newValue) => {
    if (newValue) {
        client.value = null
        endDate.value = ''
        startDate.value = ''
        autogenerate.value = false
        displayAlert.value = false
    }
})

const validateDates = () => {
    const start = moment(startDate.value)
    const end = moment(endDate.value)
    const now = moment()
    
    if (!start.isValid() || !end.isValid()) {
        return false
    }

    if (start.isAfter(end) || start.isSame(end) ) {
        return false
    }
    return true;
}



const close = () => {
    emit('input', false)
}

const submit = () => {
    if (!validateDates()) {
        displayAlert.value =  true
        return
    }
    const data = {
        startDate: startDate.value,
        endDate: endDate.value,
        client: client.value,
        auto: autogenerate.value
    }
    emit('submit', data)
}

</script>

<style scoped>
::v-deep(.vs__dropdown-menu) {
    max-height: 40px;
    overflow-y: auto;
}
</style>
